import React, {useEffect, useState, useRef, useCallback} from "react";
import {createUseStyles, useTheme} from "react-jss";
import APICallExternal from "../../../../../../../artibulles-cis/utils/APICallExternal";
import Button from "@artibulles-cis/react/Button";
import LocalCircularLoader from "@artibulles-cis/react/LocalCircularLoader";
import {toast} from "react-toastify";
import CardModal from "@artibulles-cis/react/CardModal";
import TabNavContent from "@artibulles-cis/react/TabNavContent";
import AGGridTable from "../../../../../../../artibulles-cis/AGGridTable/AGGridTable";
import CustomerEditContact from "./CustomerEditContact";
import {AddCircle} from "@artibulles-cis/react-icons";

//eslint-disable-next-line
const styles = createUseStyles((theme) => ({
    FormField: {
        flex: "0 1 600px",
        margin: "5px 10px 5px 10px",
    },
    TableWrapper: {
        position: "relative",
        boxSizing: "border-box",
        padding: "5px 0px",
        display: "flex",
        width: "100%",
        // maxWidth: "1200px",
        // maxHeight: "800px",
        height: "250px",
        margin: "0 auto",
        justifyContent: "center",
    },
    ClassExtendTabContent: {
        padding: "0px 5px 0px 5px",
        boxSizing: "border-box",
        // maxWidth: "1200px",
    },
    ClassExtendButton: {
        fontSize: "0.8rem",
        margin: "0px 0px",
        padding: "0px 5px",
        justifyContent: "flex-start",
    },
}));

const CustomerEditBankAccountTable = React.memo(function CustomerEditBankAccountTable(props) {
    const {CompanyId} = props;
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** REFS ******************/
    const Ref_LocaleData = useRef();
    /***************** REFS ******************/

    /***************** CONST ******************/
    const DevMode = process.env.NODE_ENV === "development" ? true : false;
    const ProdURL = DevMode ? "" : "https://artibulles-bms.artibulles.com";
    const HandleEditRow = (Id, RowData) => {
        setShowViewCard(true);
        setViewCardId(Id);
    };

    const DeleteCondition = (args) => {
        let status_invoice = args.status_invoice;
        if (status_invoice === "Draft") {
            return true;
        } else {
            return true; //DEVONLY!! Should be false
        }
    };
	const HandleDeleteRow = (Id) => {
        // console.log("HandleDeleteRow", Id);
        if (Id) {
			
            const ApiCall = {url: `${ProdURL}/api/companies/contact/bycompany/delete/${Id}`, type: "delete"};
            setLoading(true);
            setAPICallType("deleteone");

            async function APIInternal() {
                const res = await APICallExternal(ApiCall);
                setApiRes(res);
                setLoading(false);
            }

            APIInternal();
        }
    };
    const ColumnButtonStyle = {
        Width: 95,
        padding: "0px 0px 0px 0px",
    };
    const TableRowButtons = [
        {
            Standard: true,
            Name: "Edit",
            ActiveCondition: null,
            Index: 1,
            OnClick: HandleEditRow,
            // IconSize: "10px",
            // ActiveColor: "red",
            // HoverColor: "green",
            // InactiveColor: "blue",
            Tooltip: {Show: true, Position: "right", Theme: "light"},
        },

        {
            Standard: true,
            Name: "Delete",
            ActiveCondition: DeleteCondition,
            Index: 3,
            OnClick: HandleDeleteRow,
            ConfirmationMessage: true,
            // IconSize: "10px",
            // ActiveColor: "red",
            // HoverColor: "green",
            // InactiveColor: "blue",
            Tooltip: {Show: true, Position: "right", Theme: "light"},
        },
    ];

    const TableColumns = [
        {
            field: "Contact.LastName",
            headerName: "Last Name",
            headerClass: "ag-CenterHeader",
            flex: 1,
            filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
            sort: "asc",
            sortIndex: 1,
            sortingOrder: ["asc", "desc"],
        },
        {
            field: "Contact.FirstName",
            headerName: "First Name",
            headerClass: "ag-CenterHeader",
            flex: 1,
            filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
            // sort: "asc",
            // sortIndex: 2,
            sortingOrder: ["asc", "desc"],
        },

        {
            field: "JobTitle",
            headerName: "JobTitle",
            headerClass: "ag-CenterHeader",
            flex: 1,
            filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
            // sort: "asc",
            // sortIndex: 2,
            sortingOrder: ["asc", "desc"],
        },
        {
            field: "Email",
            headerName: "Email",
            headerClass: "ag-CenterHeader",
            flex: 1,
            filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
            // sort: "asc",
            // sortIndex: 2,
            sortingOrder: ["asc", "desc"],
        },
        {
            field: "MobilePhone",
            headerName: "MobilePhone",
            headerClass: "ag-CenterHeader",
            flex: 1,
            filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
            // sort: "asc",
            // sortIndex: 2,
            sortingOrder: ["asc", "desc"],
        },
        {
            field: "OfficePhone",
            headerName: "OfficePhone",
            headerClass: "ag-CenterHeader",
            flex: 1,
            filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
            // sort: "asc",
            // sortIndex: 2,
            sortingOrder: ["asc", "desc"],
        },

        {
            field: "IsDefault",
            headerName: "Default",
            headerClass: "ag-CenterHeader",
            flex: 1,
            Type: "Boolean",
            filterParams: {buttons: ["apply", "reset"], closeOnApply: true},
            // sort: "asc",
            // sortIndex: 2,
            sortingOrder: ["asc", "desc"],
        },
    ];
    const TableOptions = {
        // Selection: {
        //     // Multiple: true,
        //     WithCheckBox: true,
        // },
        Resizable: true,
        Sortable: true,
        Filterable: true,
        SupressMenu: true,
        WrapText: true,
        WrapHeader: false,
        HeaderHeight: 30,
        RowHeight: 24,
        RowFontSize: "13px",
        HeaderFontSize: "14px",
        StatusBar: true,
    };

    /***************** CONST ******************/

    /***************** STATE ******************/

    const [Init, setInit] = useState(false);
    const [CreateNewOnly, setCreateNewOnly] = useState(false);

    const [APICallType, setAPICallType] = useState(null);
    const [ShowViewCard, setShowViewCard] = useState(false);
    const [ViewCardId, setViewCardId] = useState(null);
    const [ApiRes, setApiRes] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [TableComponent, setTableComponent] = useState(null);
    /***************** STATE ******************/

    /***************** CALLBACK ******************/
    const EndofAPI = useCallback(() => {
        //Making sure the Loading is done and the Results are ready

        if (!Loading && ApiRes) {
            if (ApiRes.error) {
                console.log("error", ApiRes);
            } else {
                if (ApiRes && ApiRes.data && ApiRes.data.data) {
                    let Data = ApiRes.data.data;
                    console.log("Bank Account Data", Data);

                    if (Init === false) {
                        console.log("not init");

                        if (Data.CompanyContacts && Array.isArray(Data.CompanyContacts) && Data.CompanyContacts.length > 0) {
                            Ref_LocaleData.current = Data;
                            setInit(true);
                        } else {
                            //There is no bank account, we display a add button
                            console.log("New ONly");
                            setCreateNewOnly(true);
                            setInit(true);
                        }
                    }
                } else {
                    if (APICallType === "deleteone") {
                        toast.success(`Entry deleted`, {autoClose: true});
                        setInit(false);
                    }
                }
            }
        }
    }, [ApiRes, Loading]);

    const GenerateTableComponent = useCallback(() => {
        let FinalTableComponent = (
            <AGGridTable
                TableName="CompanyContacts"
                Data={Ref_LocaleData.current}
                TableColumns={TableColumns}
                MainDataSource="CompanyContacts"
                RowActionButtons={TableRowButtons}
                ColumnButtonStyle={ColumnButtonStyle}
                TableOptions={TableOptions}
                // ReloadData={ReloadTableData}
                // SyncReloadDataStateFunction={setReloadTableData}
                // TotalRow={TotalRow}
                // PaginationOptions={{
                //     Pagination: true,
                //     PageSize: 50,
                // }}
            />
            // <Table
            //     LocalData={Ref_LocaleData.current}
            //     // URLRelative={FinalAPIUrlRelative}
            //     // URLRelative="arnaud"
            //     MainDataSource="CompanyBankAccount"
            //     ColomnsInput={ColomnsInput}
            //     TableDimensions={TableDimensions}
            //     TableOptions={TableOptions}
            //     TotalRow={TotalRow}
            //     DevMode={false}
            // />
        );
        setTableComponent(FinalTableComponent);
    }, [Ref_LocaleData.current, Init]);
    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/
    useEffect(() => {
        if (Init === false) {
            const ApiCall = {url: `${ProdURL}/api/mycompany/contacts/?companyid=${CompanyId}`, type: "get"};
            setLoading(true);
            setAPICallType(null);

            async function APIInternal() {
                const res = await APICallExternal(ApiCall);
                setApiRes(res);
                setLoading(false);
            }

            APIInternal();
        }
    }, [Init]);

    useEffect(() => {
        //Used to prevent executing the core function multiple times
        if (!Loading && ApiRes) {
            EndofAPI();
        }
    }, [Loading, ApiRes]);

    useEffect(() => {
        if (Init === true && CreateNewOnly === false) {
            GenerateTableComponent();
        }
    }, [GenerateTableComponent, Init]);
    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/
    const HandleCloseViewCard = () => {
        setShowViewCard(false);
        setViewCardId(null);
        setCreateNewOnly(false);
        setTimeout(() => {
            setInit(false);
        }, 50);
    };

    const HanldeCreateNewBankAccount = () => {
        setShowViewCard(true);
        setViewCardId("new");
    };
    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/
    var ModalCardView;
    if (ShowViewCard === true) {
        ModalCardView = (
            <CardModal
                // CardID="HealFit_CreateDailyIntake"
                // ParentCompRef={Ref_TabNavContent}
                // TopBarContent={CardTitle}
                CloseCard={HandleCloseViewCard}
                CloseOnClickOutside={false}
                WithCloseButton={true}
                CardMaxWidth="570px"
                CardHeight="600px"
                // CardWindowPaddingVertical="10px"
                CardWindowPaddingHorizontal="10px"
                WithPerfectScrollbar={true}
                // CardWindowPaddingVertical="50px"

                ShowCard={true}
                WindowBackgroundColor="rgba(0,0,0,0.3)"
                CardBackgroundColor="white"
                CardBackground="white"
                ClassExtendCard={classes.ClassExtendCard}
            >
                <div className={classes.CardContent}>
                    <CustomerEditContact CompanyId={CompanyId} ContactId={ViewCardId} CloseCard={HandleCloseViewCard} />
                </div>
            </CardModal>
        );
    }
    var FinalTableComponent;

    if (Init === true) {
        if (TableComponent) {
            FinalTableComponent = (
                <div>
                    <Button
                        Width="120px"
                        Height="22px"
                        ClassExtendButton={classes.ClassExtendButton}
                        style={{fontSize: "0.8rem", margin: "0px 0px", justifyContent: "space-between"}}
                        onClick={HanldeCreateNewBankAccount}
                    >
                        <AddCircle SVGFillColor="white" IconSize="18" />
                        Add Contact
                    </Button>

                    <div className={classes.TableWrapper}>{TableComponent}</div>
                </div>
            );
        } else {
            FinalTableComponent = (
                <Button
                    Width="120px"
                    Height="22px"
                    ClassExtendButton={classes.ClassExtendButton}
                    style={{fontSize: "0.8rem", margin: "0px 0px", justifyContent: "space-between"}}
                    onClick={HanldeCreateNewBankAccount}
                >
                    <AddCircle SVGFillColor="white" IconSize="18" />
                    Add Contact
                </Button>
            );
        }
    } else {
        FinalTableComponent = "There is no data";
    }

    return (
        <TabNavContent ClassExtendTabContent={classes.ClassExtendTabContent}>
            {ModalCardView}
            <div className={classes.DailytButtonBar}>
                <div className={classes.FormField} style={{flex: "1 1 250px", maxWidth: "250px", width: "250px"}}></div>
            </div>
            <LocalCircularLoader Loading={Loading} WithModalCard={true} FullSize={true} />

            {FinalTableComponent}
        </TabNavContent>
    );

    /***************** RENDER ******************/
});

export default CustomerEditBankAccountTable;
